import script from "./TextSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./TextSwitch.vue?vue&type=style&index=0&id=156f469e&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-156f469e"]])

export default __exports__